import {Component, EventEmitter, OnInit, Input, Output} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {debounceTime, distinctUntilChanged, switchMap} from 'rxjs/operators';
import {RecipeService} from '../shared/services';
import {Observable} from "rxjs";

@Component({
  selector: 'app-recipes-search',
  templateUrl: './recipes-search.component.html',
  styleUrls: ['./recipes-search.component.scss']
})
export class RecipesSearchComponent implements OnInit {

  searchBoxValue: string;
  @Output() searchStatusChange = new EventEmitter<boolean>();
  @Input() searchToggleStatus: boolean;
  @Output() closeSearch = new EventEmitter<boolean>();
  constructor(private recipeService: RecipeService) { }
  private searchTerms = new Subject<string>();

  ngOnInit() {
    this.searchBoxValue = '';
    this.searchStatusChange.emit(this.changeSearchStatus());

    this.recipeService.getSearchStatus().subscribe(isChangedFilters => {
      if (isChangedFilters) {
        this.searchStatusChange.emit(false);
        this.searchBoxValue = '';
        this.recipeService.setFilter('wordfiltr', undefined);
      }
    });

    this.recipeService.sortHashObs.subscribe(num => {
      if (num === 5) {
        this.searchBoxValue = this.recipeService.searchItem;
        this.recipeService.setFilter('wordfiltr', (this.recipeService.searchItem));
        this.recipeService.pushProgressInHash('search');
        this.search(this.recipeService.searchItem);
      }
    });

    this.searchTerms.pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap((term: string) => {
          if (term === '' || term.length > 2) {
            this.recipeService.setSearchStatus(term.trim() === '');
            this.recipeService.setFilter('wordfiltr', (term.trim()) === '' ? undefined : term);
          }
          this.recipeService.getShort();
          return this.recipeService.get();
        })).subscribe();
  }

  checkForEnter(event): boolean {
    return (event && event.keyCode === 13);
  }

  search(term: string, e?: any): void {
    this.searchTerms.next(term);
    this.searchStatusChange.emit(this.changeSearchStatus());

    if (this.checkForEnter(e)) {
      this.closeSearch.emit(true);
      document.getElementById('search-box').blur();
    }
  }

  resetSearch() {
    this.searchBoxValue = '';
    this.search(this.searchBoxValue);
  }

  changeSearchStatus() {
    return (this.searchBoxValue.length > 0);
  }

}



// WEBPACK FOOTER //
// ./src/app/recipes-search/recipes-search.component.ts